import { registerView, View, ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import * as React from "react";
import { Form } from "react-bootstrap";
import OmissionViewModel from "viewModels/notice/omission/omissionViewModel";
import MethodOfSignature from "views/notice/components/methodOfSignature";
import Toolbox from "../components/toolbox";
import LoadingModal from "../../common/loadingModal/loadingModal";
import ErrorCard from "../../common/error/errorCard";
import DocumentUploader from "../components/documentUploader";
import { Alert } from "react-bootstrap";

const OmissionView: ViewComponent<OmissionViewModel> = observer(({ vm }) => {
  const tg = (code: string) => vm.localizationService.translateGeneral(`omission.${code}`);
  const formRef = useCallback((node) => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  return (
    <>
      <View vm={vm.outagesViewModel} />
      <div className="bg-white p-3 p-lg-4 p-xl-7 rounded">
        <Form className="p-3 p-lg-4 p-xl-7" ref={formRef}>
          <ErrorCard message={vm.errorMessage} sticky={true} />
          <div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
            <h3>{tg("title")}</h3>
          </div>
          <View vm={vm.vehicleInfoViewModel} />
          <View vm={vm.applicantPersonViewModel} />
          <View vm={vm.operatorViewModel} />
          <MethodOfSignature vm={vm} />
          <DocumentUploader vm={vm} />
          {vm.cancellationApplicationProduction?.rejectionReason && (
            <Alert key={vm.cancellationApplicationProduction.rejectionReason} variant="danger">
              <strong className="font-size-sm">
                {vm.translateWarningReason(vm.cancellationApplicationProduction.rejectionReason)}
              </strong>
            </Alert>
          )}
          <Toolbox vm={vm} />
          <LoadingModal translate={vm.translateGeneral} isVisible={vm.showLoadingModal} />
        </Form>
      </div>
    </>
  );
});

registerView(OmissionView, OmissionViewModel);
